import { ITableField } from 'shared/Table'
import { IMeRegistrations } from 'screens/Protection/protection.types'

const ProtectionsTableFields: ITableField<IMeRegistrations, keyof IMeRegistrations>[] = [
  {
    key: 'roomName',
    getter: (item) => item.roomName,
    sortGetter: (item) => item.roomName,
    header: 'Аудитория',
    width: '300px',
  },
  {
    key: 'defenceName',
    getter: (item) => item.defenceName,
    sortGetter: (item) => item.defenceName,
    header: 'Защита',
    width: '300px',
  },
  {
    key: 'teamName',
    getter: (item) => item.teamName,
    sortGetter: (item) => item.teamName,
    header: 'Команда',
    width: '300px',
  },
  {
    key: 'presentationOrder',
    getter: (item) => item.presentationOrder.toString(),
    sortGetter: (item) => item.presentationOrder,
    header: 'Порядок выступления',
    width: '200px',
  },
]

export default ProtectionsTableFields
